import { ScriptSureControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

export interface SyncScriptsureAllergiesProps {
  patientId: string;
  xTENANTID: string;
}

export const useSyncScriptsureAllergies = () =>
  useMutationWithLoading(
    ({ patientId, xTENANTID }: SyncScriptsureAllergiesProps) =>
      new ScriptSureControllerApi(getConfigObject()).getPatientById(
        patientId,
        xTENANTID
      )
  );
